import twemoji from "twemoji"
import { CountryInfoContainer } from "./Components"

export const CountryInfo = ({row}) => {
    return (<CountryInfoContainer dangerouslySetInnerHTML={{ __html: twemoji.parse(row.country?`${row.country}${row.city?`/${row.city}`:``}`:`Unknown`) }} />)
}